export enum DirectionEnum {
  'TOP',
  'TOP-RIGHT',
  'RIGHT',
  'BOTTOM-RIGHT',
  'BOTTOM',
  'BOTTOM-LEFT',
  'LEFT',
  'TOP-LEFT',
}

export enum ActionPhase {
  NONE = 'none',
  CASTING = 'casting',
  EXECUTING = 'executing',
  LAGGING = 'lagging',
}

export enum LagType {
  NONE = 'none',
  FULL = 'full',
  CAST = 'cast',
}

export enum DungeonEntityType {
  PLAYER = 'player',
  MONSTER = 'monster',
  ITEM = 'item',
}

export enum ActionDirectionType {
  ALL = 'all', // No direction restriction, range (distance) only
  ALIGNED = 'aligned', // Aligned in one of the 8 directions (diagonals included)
  LIMITED_ALIGNED = 'limited_aligned', // Aligned in one of the 4 cardinal directions (up, down, left, right)
}

export enum EffectShape {
  SINGLE = 'single', // A single cell
  LINE = 'line', // Line in a direction
  CROSS = 'cross', // Cross (4 directions)
  SQUARE = 'square', // Square around the point
  CIRCLE = 'circle', // Circle (approximate)
  CONE = 'cone', // Cone in a direction
  CUSTOM = 'custom', // Custom shape
  SWIPE = 'swipe', // Sweep effect in a direction
  ROOM = 'room', // All cells of the caster's room
}

export enum RangeAlgorithm {
  CHEBYSHEV = 'chebyshev', // Chebyshev distance (max(|dx|, |dy|)) - default for 8-direction grids
  EUCLIDEAN = 'euclidean', // Euclidean distance (√(dx² + dy²)) - true distance
}

export enum AIBehaviorState {
  IDLE = 'idle', // No information about the player, static natural behavior
  PATROL = 'patrol', // Natural patrol
  ALERT = 'alert', // Knows a player is nearby but does not see them
  CHASE = 'chase', // Chases the player toward their last known position
  COMBAT = 'combat', // Player is visible, active combat
  FLEE = 'flee', // Fear / low HP: moves away from the player
}

/**
 * The 6 emotions, used as elemental types with a fixed Pokémon-style
 * effectiveness chart (see EMOTION_EFFECTIVENESS in data/emotions.config.ts).
 * Display names are placeholders until the story locks them in.
 *
 * `neutral` is a 7th, special type reserved for a few specific actions (basic
 * attack without a major trinket, bleed): it always deals x1 elemental (no
 * resist/weakness link to any emotion) and is intentionally excluded from
 * `ELEMENTS` so it never enters random-element pools or emotion iteration.
 */
export type Element =
  | 'joy'
  | 'sadness'
  | 'anger'
  | 'fear'
  | 'surprise'
  | 'disgust'
  | 'neutral';

export const ELEMENTS: readonly Element[] = [
  'joy',
  'sadness',
  'anger',
  'fear',
  'surprise',
  'disgust',
] as const;
